import { createNativeStackNavigator } from '@react-navigation/native-stack';
import CompaniesListScreen from './CompaniesList';
import CompanyManageScreen from './CompanyManage';

const Stack = createNativeStackNavigator();

export default function Companies({ navigation }: { navigation: any }) {
  return (
    <Stack.Navigator>
      <Stack.Screen name="list" component={CompaniesListScreen} options={{ headerShown: false, title: 'Companies'  }} />
      <Stack.Screen name="manage" component={CompanyManageScreen} options={{ headerShown: false, title: 'Company Manage'}}  />
    </Stack.Navigator>
  )
};